export function formatDate(date) {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
}

export const formatToYYYYMMDD = (dateInput) => {
  const date = new Date(dateInput);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const formatTimestamp = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);

  const pad = (n) => String(n)?.padStart(2, "0");

  const year = date?.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date?.getUTCDate());
  const hours = pad(date?.getUTCHours());
  const minutes = pad(date?.getUTCMinutes());
  const seconds = pad(date?.getUTCSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatLocalTimestamp = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);

  const pad = (n) => String(n)?.padStart(2, "0");

  const year = date?.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date?.getDate());
  const hours = pad(date?.getHours());
  const minutes = pad(date?.getMinutes());
  const seconds = pad(date?.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
export function formatDateString(dateString) {
  if (!dateString) return "";

  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}
